import { Instagram, Mail, MapPin, Phone } from "lucide-react";
import { Link } from "react-router-dom";
import { Reveal } from "./Reveal";
import { ProPractBadge } from "./ProPractBadge";
import { useSite } from "@/lib/site";

export const Footer = ({ onBook }) => {
  const { content } = useSite();
  const s = content.settings || {};
  return (
  <footer data-testid="site-footer" className="bg-ink pt-20 text-sand">
    <div className="mx-auto max-w-7xl px-4 sm:px-8 lg:px-16">
      <Reveal className="flex flex-col items-start justify-between gap-10 border-b border-sand/10 pb-14 lg:flex-row lg:items-end">
        <div className="flex-1">
          <p className="font-display text-5xl font-medium leading-none sm:text-7xl">
            The Birth <span className="italic text-terra">Life</span>
          </p>
          <p className="mt-4 max-w-md text-sm leading-relaxed text-sand/60">
            Supporting parents, nurturing babies — making 20,000 families strong.
          </p>
        </div>
        {onBook ? (
          <button
            data-testid="footer-book-cta"
            onClick={() => onBook()}
            className="rounded-full bg-terra px-8 py-4 font-outfit text-sm font-semibold text-white transition-all duration-300 hover:bg-terradark hover:shadow-deep"
          >
            Book your consultation
          </button>
        ) : (
          <Link
            data-testid="footer-book-cta"
            to="/"
            className="rounded-full bg-terra px-8 py-4 font-outfit text-sm font-semibold text-white transition-all duration-300 hover:bg-terradark hover:shadow-deep"
          >
            Book your consultation
          </Link>
        )}
      </Reveal>

      <div className="grid grid-cols-1 gap-10 py-12 sm:grid-cols-3">
        <div>
          <p className="font-outfit text-xs font-semibold uppercase tracking-[0.25em] text-sand/40">Visit</p>
          <p className="mt-3 flex items-start gap-2 text-sm text-sand/70" data-testid="footer-location">
            <MapPin className="mt-0.5 h-4 w-4 shrink-0 text-terra" />
            {s.location_text || "CK Birla Hospital rounds · Gurgaon, Haryana, India"}
          </p>
        </div>
        <div>
          <p className="font-outfit text-xs font-semibold uppercase tracking-[0.25em] text-sand/40">Connect</p>
          <div className="mt-3 space-y-2 text-sm text-sand/70">
            <a data-testid="footer-instagram" href={s.instagram_url || "https://www.instagram.com/thebirth.life"} target="_blank" rel="noopener noreferrer" className="flex items-center gap-2 transition-colors hover:text-terra">
              <Instagram className="h-4 w-4 text-terra" /> {s.instagram_handle || "@thebirth.life"} · 300K community
            </a>
            <p className="flex items-center gap-2">
              <Mail className="h-4 w-4 text-terra" /> {s.email || "birthlifeindia@gmail.com"}
            </p>
            <p className="flex items-center gap-2">
              <Phone className="h-4 w-4 text-terra" /> {s.phone_display || "Consults online worldwide"}
            </p>
          </div>
        </div>
        <div>
          <p className="font-outfit text-xs font-semibold uppercase tracking-[0.25em] text-sand/40">Platform</p>
          <div className="mt-3">
            <ProPractBadge href="https://propract.com" />
          </div>
        </div>
      </div>

      <div className="flex flex-col items-center justify-between gap-3 border-t border-sand/10 py-6 text-xs text-sand/40 sm:flex-row">
        <p data-testid="footer-copyright">© {new Date().getFullYear()} The Birth Life · Yogyata Wadhwa, IBCLC</p>
        <div className="flex items-center gap-5">
          <Link data-testid="footer-terms-link" to="/terms" className="transition-colors hover:text-terra">Terms & Conditions</Link>
          <Link data-testid="footer-privacy-link" to="/privacy" className="transition-colors hover:text-terra">Privacy Policy</Link>
          <span>Educational content is not a substitute for medical advice.</span>
        </div>
      </div>
    </div>
  </footer>
  );
};
